import { ACTION_CONSTANTS } from 'actions/constants';

const INITIAL_STATE = { open: false };

export function overlay(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ACTION_CONSTANTS.overlay.open:
      return { open: true, ...action.payload };
    case ACTION_CONSTANTS.overlay.close:
      return INITIAL_STATE;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/overlay.js